const LayerSystem = (function () {
  const isTouchDevice = () => "ontouchstart" in document.documentElement;
  let viewportHeight = 0;
  let $layerItems;
  let allLayers = [];

  function setupLayers() {
    killLayers();
    // Maak voor elke layer een 'ScrollTrigger' aan.
    $layerItems.each(function (index, element) {
      if ($layerItems.length <= 1) {
        // Geen layer-magie als er maar 1 layer is.
        return;
      }
      if ($(element).parent(".js-layer-pin-spacer").length == 0) {
        // We gebruiken een custom spacer element. dit voorkomt dat er lagen opnieuw gerenderd worden als de viewport resized.
        $(element).wrap("<div class='js-layer-pin-spacer'></div>");
      }
      allLayers.push(createScrollTriggerInstance($(element), index));

      // Voeg een z-index toe zodat layers niet overlappen
      $(element).css("z-index", index);
    });
  }

  function killLayers() {
    allLayers.forEach((layer) => {
      layer.kill();
    });
    allLayers = [];
  }

  function getLayerOffsetRelativeToVh(element) {
    const elHeight = $(element).innerHeight();
    const vh = viewportHeight || getViewportHeight();
    return elHeight < vh ? vh - elHeight : 0;
  }

  function createScrollTriggerInstance(element, index) {
    // De viewportHeight wordt afgeleid van een element dat in de viewport staat, omdat 100vh wisselt op mobile en we daar niet van uit kunnen gaan. Op iPhones wissen de 100vh bijvoorbeeld als de adresbalk in beeld komt en wordt er een resize getriggerd.

    // Bereken een 'korte maand', die niet de hele viewport vult
    function getOffset() {
      if (index === $layerItems.length) {
        return 0;
      } else {
        return getLayerOffsetRelativeToVh($(element));
      }
    }

    // maak de ScrollTrigger scenes aan
    const getStartPos = () => {
      const offset = getOffset();
      return offset > 0
        ? `bottom+=${offset} top+=${viewportHeight}`
        : `bottom top+=${viewportHeight}`;
    };

    // Custom resize events zijn niet nodig omdat ScrollTrigger dit automatisch al doet, mits de start en end een functie bevatten.
    // We specificeren hier geen end trigger omdat dit de performance enorm vertraagt (getest door Bram op test.doornroosje).
    return ScrollTrigger.create({
      id: `layer-${index}`,
      trigger: $(element),
      start: () => getStartPos(),
      anticipatePin: 1,
      pinSpacer: $(element).parent(".js-layer-pin-spacer"), // toegevoegd zodat lagen niet opnieuw gerenderd worden op resize
      pinSpacing: false,
      pin: true,
      scrub: 0.5,
    });
  }

  function getViewportHeight() {
    let measuredVh = null;
    $(
      '<div id="measure-vh" style="position: fixed; height: 100lvh; opacity: 0; pointer-events: none;"></div>'
    ).appendTo("body");
    measuredVh = $("#measure-vh").innerHeight();
    $("#measure-vh").remove();
    return measuredVh;
  }


  function init() {
    if (Global.debug.disableLayers) return;
    $layerItems = $(".js-layer");
    updateViewportHeight();
    setupLayers();  
    addMobileEventListenerForInputFieldBug();
  }

  function reset() {
    if (Global.debug.disableLayers) return;
    $layerItems = $(".js-layer");
    updateViewportHeight();
    setupLayers();
  }

  function updateViewportHeight(updateLayers) {
    const newViewportHeight = getViewportHeight();
    // Als de viewportHeight meer dan 25% verschilt van de oude viewportHeight, dan updaten we de viewportHeight en de layers. Dit om op mobile resize te voorkomen als de adresbalk in beeld komt.
    if (!isTouchDevice()) {
      // Op desktop
      viewportHeight = getViewportHeight();
      if (updateLayers) {
        LayerSystem.update();
      }
    } else {
      // Op een touch device
      const oldViewportHeight = viewportHeight;
      const percentagDifference = Math.abs(
        ((oldViewportHeight - newViewportHeight) / oldViewportHeight) * 100
      );
      if (percentagDifference > 25) {
        viewportHeight = getViewportHeight();
        if (updateLayers) {
          LayerSystem.update();
        }
      }
    }
  }
  $(".js-program-search-layer .js-filter-search-input");

  function addMobileEventListenerForInputFieldBug() {
    $(
      ".js-newsletter input, .js-program-search-layer .js-filter-search-input"
    ).off("focus");
    $(
      ".js-newsletter input, .js-program-search-layer .js-filter-search-input"
    ).on("focus", function () {
      // Only on touch devices
      if (!isTouchDevice()) return;
      // Disable scrolltrigger instance so that the input says visible
      allLayers.forEach((layer) => {
        layer.disable();
      });
      // Make the input always in viewport, 200ms after focus
      setTimeout(() => {
        const offsetFromTop = $(this).offset().top;
        $(window).scrollTop(offsetFromTop - 250);
      }, 200);
      // Add a event handler to re-enable scrolltrigger when the input is blurred
      $(this).off("blur");
      $(this).one("blur", function () {
        allLayers.forEach((layer) => {
          layer.enable();
        });
      });
      // Sometimes, the input gets immediately un-focussed after the user clicks on it because resize is triggered or something. We trigger the focus event manually.
      if (!$(this).is(":focus")) {
        $(this).trigger("focus");
      }
    });
  }

  return {
    init,
    reset,
    viewportHeight,
    updateViewportHeight,
    update: () => ScrollTrigger.refresh(),
  };
})();

$(window).on(
  "resize",
  debounce(function () {
    LayerSystem.updateViewportHeight(true);
  }, 250)
);
